import React from "react";
import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "leaflet/dist/leaflet.css";

import AdminLayout from "./components/layouts/AdminLayout";
// import AdminLayoutTabStyle from "./components/layouts/AdminLayoutTabStyle";
import LandingLayout from "./components/layouts/LandingLayout";
import MonitoringLayout from "./components/layouts/MonitoringLayout";
import ProtectedRoute from "./components/auth/ProtectedRoute";

// Landing Pages
import Landing from "./pages/public/landing/index";
import Service from "./pages/public/services/Service";
import About from "./pages/public/about/About";
import Research from "./pages/public/research/Research";
import Product from "./pages/public/products/Product";
import AllProduct from "./pages/public/products/AllProduct";
import Blog from "./pages/public/blog/Blog";
import Contact from "./pages/public/contact/Contact";
import Login from "./pages/auth/Login";

// Admin Pages
import Dashboard from "./pages/protected/admin/Dashboard";
import Attendance from "./pages/protected/admin/Attendance";
// Projects
import Projects from "./pages/protected/admin/project/Projects";
import ShowProject from "./pages/protected/admin/project/ShowProject";
import AddProject from "./pages/protected/admin/project/AddProject";
import EditProject from "./pages/protected/admin/project/EditProject";
import ProjectMap from "./pages/protected/admin/project/ProjectMap";
import MapOverview from "./pages/protected/admin/project/MapOverview/index.jsx";
// Excavation
import Excavation from "./pages/protected/admin/excavation/Excavation";
import ExcavationMap from "./pages/protected/admin/excavation/ExcavationMap/index.jsx";
import ShowExcavation from "./pages/protected/admin/excavation/ShowExcavation";
import AddExcavation from "./pages/protected/admin/excavation/AddExcavation";
import EditExcavation from "./pages/protected/admin/excavation/EditExcavation";
// Reports
import Report from "./pages/protected/admin/report/Reports";
import ShowReport from "./pages/protected/admin/report/ShowReport";
import AddReport from "./pages/protected/admin/report/AddReport";
import EditReport from "./pages/protected/admin/report/EditReport";
// Products
import AdminProducts from "./pages/protected/admin/product/Products";
import AddProduct from "./pages/protected/admin/product/AddProduct";
import EditProduct from "./pages/protected/admin/product/EditProduct";
import AdminProductDetail from "./pages/protected/admin/product/ProductDetail";
// Research
import AdminResearch from "./pages/protected/admin/research/Research";
import AdminResearchDetail from "./pages/protected/admin/research/ResearchDetail";
import AddResearch from "./pages/protected/admin/research/AddResearch";
import EditResearch from "./pages/protected/admin/research/EditResearch";
// Clients
import Client from "./pages/protected/admin/client/Clients";
import AddClient from "./pages/protected/admin/client/AddClient";
import EditClient from "./pages/protected/admin/client/EditClient";
// User
import Users from "./pages/protected/admin/user/Users";
import AddUser from "./pages/protected/admin/user/AddUser";
import EditUser from "./pages/protected/admin/user/EditUser";
// Employees
import Employees from "./pages/protected/admin/employee/Employees";
import AddEmployee from "./pages/protected/admin/employee/AddEmployee";
import EditEmployee from "./pages/protected/admin/employee/EditEmployee";
// Settings
import Settings from "./pages/protected/admin/Settings";

// Monitoring Pages
import Overview from "./pages/protected/monitoring/Overview";
import ModuleList from "./pages/protected/monitoring/module/ModuleList";
import ModuleDetail from "./pages/protected/monitoring/module/ModuleDetails";
import Performance from "./pages/protected/monitoring/Performance";
import Alerts from "./pages/protected/monitoring/Alerts";
import Logs from "./pages/protected/monitoring/Logs";
import MonitoringReports from "./pages/protected/monitoring/Reports";

const App = () => {
  useEffect(() => {
    const expiresAt = localStorage.getItem("expiresAt");
    if (expiresAt && Date.now() > parseInt(expiresAt)) {
      localStorage.clear();
      window.location.href = "/login";
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Public Landing Routes */}
        <Route element={<LandingLayout />}>
          <Route index element={<Landing />} />
          <Route path="service" element={<Service />} />
          <Route path="about" element={<About />} />
          <Route path="research" element={<Research />} />
          <Route path="product" element={<Product />} />
          <Route path="product/all-product" element={<AllProduct />} />
          <Route path="blog" element={<Blog />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        {/* Auth Routes */}
        <Route path="login" element={<Login />} />

        {/* Protected Admin Routes */}
        <Route
          path="admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
              {/* <AdminLayoutTabStyle /> */}
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="employees">
            <Route index element={<Employees />} />
            <Route path="add" element={<AddEmployee />} />
            <Route path="edit/:id" element={<EditEmployee />} />
          </Route>
          <Route path="users">
            <Route index element={<Users />} />
            <Route path="add" element={<AddUser />} />
            <Route path="edit/:id" element={<EditUser />} />
          </Route>
          <Route path="client">
            <Route index element={<Client />} />
            <Route path="add" element={<AddClient />} />
            <Route path="edit/:id" element={<EditClient />} />
          </Route>
          {/* Projects */}
          {/* <Route path="projects">
            <Route index element={<Projects />} />
            <Route path="show/:id" element={<ShowProject />} />
            <Route path="map" element={<ProjectMap />} />
            <Route path="excavation" element={<Excavation />} />
            <Route path="show/:id/excavation" element={<ShowExcavation />} />
            <Route path="add" element={<AddProject />} />
            <Route path="edit/:id" element={<EditProject />} />
          </Route>
          <Route path="excavation">
            <Route index element={<Excavation />} />
            <Route path="map" element={<ExcavationMap />} />
            <Route path="excavation" element={<Excavation />} />
          </Route> */}
          {/* Projects */}
          <Route path="projects">
            <Route index element={<Projects />} />
            <Route path="show/:id" element={<ShowProject />} />
            <Route path="map" element={<ProjectMap />} />
            <Route path="map-overview" element={<MapOverview />} />

            {/* Excavation masuk ke dalam project */}
            <Route path="excavation">
              <Route index element={<Excavation />} />
              <Route path="map" element={<ExcavationMap />} />
              <Route path="add" element={<AddExcavation />} />
              <Route path="edit/:id" element={<EditExcavation />} />
              <Route path="show/:id" element={<ShowExcavation />} />
            </Route>

            <Route path="add" element={<AddProject />} />
            <Route path="edit/:id" element={<EditProject />} />
          </Route>

          <Route path="reports">
            <Route index element={<Report />} />
            <Route path="show/:id" element={<ShowReport />} />
            <Route path="add" element={<AddReport />} />
            <Route path="add/:projectId" element={<AddReport />} />
            <Route path="edit/:id" element={<EditReport />} />
          </Route>
          <Route path="products">
            <Route index element={<AdminProducts />} />
            <Route path="detail/:id" element={<AdminProductDetail />} />
            <Route path="add" element={<AddProduct />} />
            <Route path="edit/:id" element={<EditProduct />} />
          </Route>
          <Route path="researchs">
            <Route index element={<AdminResearch />} />
            <Route path="detail/:id" element={<AdminResearchDetail />} />
            <Route path="add" element={<AddResearch />} />
            <Route path="edit/:id" element={<EditResearch />} />
          </Route>
          <Route path="settings" element={<Settings />} />
        </Route>

        {/* Protected Monitoring Routes */}
        <Route
          path="monitoring"
          element={
            <ProtectedRoute>
              <MonitoringLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="overview" replace />} />
          <Route path="overview" element={<Overview />} />
          <Route path="module">
            <Route index element={<ModuleList />} />
            <Route path=":moduleId" element={<ModuleDetail />} />
          </Route>
          <Route path="performance" element={<Performance />} />
          <Route path="alerts" element={<Alerts />} />
          <Route path="logs" element={<Logs />} />
          <Route path="reports" element={<MonitoringReports />} />
        </Route>

        {/* Catch all undefined routes and redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
